import { Action } from '@ngrx/store';
import { INext } from 'src/app/models/next.interface';

export enum ENextActions {
  GetNext = '[Next] Get Next',
  GetNextSuccess = '[Next] Get Next Success'
}

export class GetNext implements Action {
  public readonly type = ENextActions.GetNext;
}

export class GetNextSuccess implements Action {
  public readonly type = ENextActions.GetNextSuccess;
  constructor(public payload: INext) {}
}

export type NextActions =
  | GetNext
  | GetNextSuccess;

